let source
// Port SSE hot-reloadu wkompilowuje bundler (bun.build.js define). Odczyt musi być gołym
// `process.env.WEBPACKER_DEV_SERVER_PORT` - guard `typeof process` zostawał w bundlu i w
// przeglądarce (brak globalnego `process`) zawsze wygrywał fallback, więc worktree pukało
// do SSE bazowego repo zamiast do swojego.
const port = process.env.WEBPACKER_DEV_SERVER_PORT
function establishEventSource() {
  if (source) {
    source.close()
  }

  source = new EventSource(`http://localhost:${port}/hot-reload`)

  source.onopen = (_event) => {
    console.log("Connected to bun live reload server")
  }

  source.onmessage = (event) => {
    const data = JSON.parse(event.data)
    if (data.type === "rebuild") {
      console.log("Rebuild detected, reloading page...")
      window.location.reload()
    }
  }

  source.onerror = (_event) => {
    // port jest wkompilowany w bundle (bun.build.js define) - bundle skopiowany z bazowego repo
    // celuje w port bazowy do pierwszego rebuildu w worktree, stąd port w komunikacie
    console.error(`Error connecting to bun live reload server on port ${port}. Make sure bin/dev is running (port from .env WEBPACKER_DEV_SERVER_PORT).`)
    source.close()
  }
}

if (process.env.NODE_ENV === "development") {
  establishEventSource()
}

// Reconnect on page visibility change (e.g., when switching tabs)
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && process.env.NODE_ENV === "development") {
    establishEventSource()
  }
})
